<template>
<div>
	<div class="wrapper">
		<div id="formContent">
			<!-- Tabs Titles -->
			<!-- Icon -->
			<div class="fadeIn first">
				<h1>Please Login</h1>
			</div>
			<!-- Login Form -->
			<form v-on:submit.prevent="doLogin">
				<input type="text" id="login" class="fadeIn second" name="login" placeholder="login" v-model="login">
				<input type="password" id="password" class="fadeIn third" name="password" placeholder="password" v-model="password">
				<input type="submit" class="fadeIn fourth" value="Log In">
			</form>
	  <vue-telegram-login mode="callback" telegram-login="Collabbot" requestAccess="write" :userpic="true" @callback="doTelegramLogin" />

			<div v-if="error" class="fadeIn error-message"><span>{{errorMessage}}</span></div>
			<div id="formFooter">
				<router-link class="underlineHover" to="/register">Register</router-link>
				<!-- <a class="underlineHover" href="#">Forgot Password?</a> -->
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {vueTelegramLogin} from 'vue-telegram-login'

export default {
  name: 'LoginPage',
  components:{
	vueTelegramLogin
  },
  data(){
	return { 
		redirect: "/",
		login: "",
		password: "",
		error: false,
		errorMessage: ""
	}
  },
	mounted(){
		if(this.$API.loggedIn){
			this.$router.push("/");
			return;
		}
		if(this.$route.query.redirect)
			this.redirect=this.$route.query.redirect;
		this.$API.title="G'day!";
	},
	methods:{
		doLogin:async function(){
			let response=await this.$API.apiPOST("/login", {login:this.login, password: this.password});
			if(response.status=="fail"){
				this.errorMessage=response.message;
				this.error=true;
			}else{
				this.$API.token=response.token;
				await this.$API.loadProfile();
				this.$API.loggedIn=true;
				this.$router.push(decodeURIComponent(this.redirect));
			}
		},
		doTelegramLogin:async function(data){
			let response=await this.$API.apiPOST("/login/telegram", data);
			if(response.status=="fail"){
				this.errorMessage=response.message;
				this.error=true;
			}else{
				this.$API.token=response.token;
				await this.$API.loadProfile();
				this.$API.loggedIn=true;
				this.$router.push(this.redirect);
			}
		}
	},
	watch:{
		login:function(){
			this.error=false;
		},
		password:function(){
			this.error=false;
		}
	}
}
</script>
<style scoped>
</style>